import React, { useContext } from 'react';
import styles from './reviewSearchAndKeywordsStyles.module.scss';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';
import { useMediaQuery } from 'usehooks-ts';
import { ProductReviewContext } from '../ProductReviewContext';
import { fireBazaarVoiceDataLayerEvent } from 'src/scripts/utils/gtm-data-layer';

const ReviewAIKeywords = ({
  keywords,
  activeKeyword,
  setActiveKeyword,
  disableShowMore = false,
}: {
  keywords: string[] | null;
  activeKeyword: string | undefined;
  setActiveKeyword: React.Dispatch<React.SetStateAction<string | undefined>>;
  disableShowMore?: boolean;
}) => {
  const productHandle = window.server_pdp_data?.product?.handle;
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT);
  const visibleKeywords = !isMobile || disableShowMore ? keywords : keywords?.slice(0, 2);
  const hasMore = keywords && keywords.length > 2;

  const { toggleProductReviewFiltersDrawer, setActiveReviewFilterAccordion } = useContext(ProductReviewContext);

  const toggleActive = (keyword: string) => {
    setActiveKeyword((prev) => (prev === keyword ? '' : keyword));
  };

  if (!keywords || keywords.length === 0) {
    return null;
  }
  return (
    <ul className={styles.reviewAIKeywords}>
      {visibleKeywords?.map((keyword) => (
        <li key={keyword}>
          <button
            onClick={() => {
              toggleActive(keyword);
              if (productHandle) {
                fireBazaarVoiceDataLayerEvent({
                  eventName: 'trackEventBV',
                  productId: productHandle, // BV wants the product handle as the productId
                  featureName: 'filter',
                });
              }
            }}
            className={`${styles.keywordButton} button-toggle${activeKeyword === keyword ? ' active' : ''} notranslate`}
          >
            {keyword}
          </button>
        </li>
      ))}
      {isMobile && hasMore && !disableShowMore && (
        <li>
          <button
            onClick={() => {
              toggleProductReviewFiltersDrawer(true);
              setActiveReviewFilterAccordion('keywords');
            }}
            className={`${styles.showMoreButton} button-toggle`}
          >
            ...
          </button>
        </li>
      )}
    </ul>
  );
};

export default ReviewAIKeywords;
